module.exports = __webpack_public_path__ + "media/custom/images/img4-2981d3bf271ea7815726c3af6391b665.svg";